'use client';

import { useTranslations } from 'next-intl';

import usePeriodText from 'hooks/usePeriodText';
import { ProductPackageDetailsDataType } from 'types/productPackage';
import { isMatchedIntroAndRecurringPricePeriod } from 'utils/isMatchedIntroAndRecurringPricePeriod';

type TotalPriceInformationProps = {
  introPrice: number;
  recurringPrice: number;
  packageDetails: ProductPackageDetailsDataType;
};

const TotalPriceInformation = ({
  introPrice,
  recurringPrice,
  packageDetails,
}: TotalPriceInformationProps) => {
  const tCheckout = useTranslations('checkout');

  const autoRenew = packageDetails.subscriptionPlan.autoRenew;
  const introductionBillingPeriod = packageDetails.billingPeriod;
  const introductionBillingFrequency = packageDetails.billingPeriodFrequency;
  const introductionBillingUnit = packageDetails.billingPeriodUnit;

  const recurringBillingPeriod = packageDetails.subscriptionPlan.billingPeriod;
  const recurringBillingFrequency = packageDetails.subscriptionPlan.billingPeriodFrequency;
  const recurringBillingUnit = packageDetails.subscriptionPlan.billingPeriodUnit;

  const isPricePeriodMatched = isMatchedIntroAndRecurringPricePeriod(
    introPrice,
    recurringPrice,
    introductionBillingPeriod,
    recurringBillingPeriod,
    introductionBillingFrequency,
    recurringBillingFrequency as number,
    introductionBillingUnit,
    recurringBillingUnit,
  );

  const recurrentPeriodText = usePeriodText(
    recurringBillingPeriod,
    recurringBillingFrequency as number,
    recurringBillingUnit,
  );

  const recurringPeriodText = isPricePeriodMatched
    ? tCheckout('totalRecurringPriceWithIntroPriceMatched', {
        period: recurrentPeriodText,
      })
    : tCheckout('totalRecurringPriceWithIntroPriceMisMatched', {
        period: recurrentPeriodText,
        amount: recurringPrice,
      });

  return (
    <div className="sm:col-span-6 flex flex-col bg-xxLight px-4 py-4 border border-dividerGrey sm:rounded-md sm:px-6 gap-y-2">
      <span className="text-sm font-bold">
        {tCheckout('totalPay', {
          amount: introPrice,
        })}
      </span>
      {autoRenew && <span className="text-sm font-normal">{recurringPeriodText}</span>}
    </div>
  );
};

export default TotalPriceInformation;
